import { render, staticRenderFns } from "./giftBag.vue?vue&type=template&id=f230fbd6&scoped=true&"
import script from "./giftBag.vue?vue&type=script&lang=js&"
export * from "./giftBag.vue?vue&type=script&lang=js&"
import style0 from "./giftBag.vue?vue&type=style&index=0&id=f230fbd6&lang=scss&scoped=true&"
import style1 from "./giftBag.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f230fbd6",
  null
  
)

export default component.exports